<template>
  <div class="table-wrapper">
    <div class="table-container">
      <v-data-table class="data-table-no-border leads-table" v-model="currentPage" :headers="headers" :items="leads"
        item-value="id" :items-per-page="leadStore.items_per_page" :hide-default-footer="true">
        <!-- platform Column -->
        <template #[`item.platform`]="{ item }">
          <div class="text-center">
            <img v-if="item.platform === 'Snapchat'" :src="snapchatIcon" :alt="item.platform" />
            <img v-if="item.platform === 'Twitter'" :src="xIcon" :alt="item.platform" />
            <img v-if="item.platform === 'Facebook'" :src="facebookIcon" :alt="item.platform" />
            <img v-if="item.platform === 'LinkedIn'" :src="LinkedInIcon" :alt="item.platform" />
            <img v-if="item.platform === 'Instagram'" :src="instagramIcon" :alt="item.platform" />
            <img v-if="item.platform === 'Tiktok'" :src="tiktokIcon" :alt="item.platform" />
          </div>
        </template>

        <!-- Phone Number Column -->
        <template #[`item.phoneNumber`]="{ item }">
          <a class="phone-link" :href="`tel:${item.phoneNumber}`">
            <img width="24px" :src="phoneIcon" :alt="item.phoneNumber" />
            <span>{{ item.phoneNumber }}</span>
          </a>
        </template>

        <!-- Leads Progress -->
        <template #[`item.leadsProgressCol`]="{ item }">
          <ProgressCol :item="item" :disabled="!$permissionsFor('leads-managment').update"
          :class="{ 'read-only': !$permissionsFor('leads-managment').update }" />
        </template>

        <!-- Status -->
        <template #[`item.status`]="{ item }">
          <StatusCol :item="item" :disabled="!$permissionsFor('leads-managment').update"
          :class="{ 'read-only': !$permissionsFor('leads-managment').update }" />
        </template>

        <!-- Comments -->
        <template #[`item.comments`]="{ item }">
          <CommentCol :item="item" />
        </template>

        <!-- Assignee -->
        <template #[`item.assignee`]="{ item }">
          <div class="d-flex align-center ga-2">
            <span v-for="(assignee, index) in item.assignee" :key="index">
              <img :title="assignee.name" class="circle-img cursor-pointer" :src="assignee.img" :alt="assignee.name" />
            </span>
            <v-btn :disabled="!$permissionsFor('leads-managment').update"
          :class="{ 'read-only': !$permissionsFor('leads-managment').update }" class="dotted-circle-btn" icon @click="handleClickPermission(item.id)">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-dialog v-model="dialog" style="max-width: 41rem" persistent>
              <v-card class="pa-12 rounded-xl">
                <v-card-title class="text-h6 pb-2">Add Agents</v-card-title>
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" placeholder="Search for an agent" dense
                  variant="outlined" class="mb-4 add-assi" hide-details />
                <v-sheet class="agent-list pa-1" elevation="1" rounded>
                  <v-row v-for="agent in agents" :key="agent.id" align="center" class="pa-2 agent-item">
                    <v-col cols="auto">
                      <v-checkbox :model-value="selected.includes(agent.id)" @change="() => toggleAssignAgent(agent.id)"
                        hide-details density="compact" class="ma-0" />
                    </v-col>
                    <v-col cols="auto">
                      <v-avatar size="32">
                        <img class="w-100" :src="agent.image" alt="image" />
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <span class="agent-name">{{ agent.first_name }}</span>
                    </v-col>
                  </v-row>
                </v-sheet>
                <v-card-actions class="justify-end mt-4">
                  <v-btn variant="outlined" class="px-6 py-2" style="
                      background-color: #f2f2f2;
                      border: none;
                      color: #4d4d4d;
                      border-radius: 0.6rem;
                    " @click="dialog = false">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
  <Pagination :store="leadStore" />
</template>

<script>
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import apiClient from "@/core/buildRequest";

import snapchatIcon from "@/assets/images/icons/snapcaht.svg";
import xIcon from "@/assets/images/icons/x.svg";
import instagramIcon from "@/assets/images/icons/instagram.svg";
import facebookIcon from "@/assets/images/icons/facebook.svg";
import tiktokIcon from "@/assets/images/icons/tiktok.svg";
import phoneIcon from "@/assets/images/icons/phone.svg";
import LinkedInIcon from "@/assets/images/icons/linkedIn.svg";
import ProgressCol from "@/components/crm/leads/ProgressCol.vue";
import StatusCol from "@/components/crm/leads/StatusCol.vue";
import CommentCol from "@/components/crm/leads/CommentCol.vue";
import Pagination from "@/components/crm/assets/Pagination.vue";
import { useGeneralStore } from "@/store/General.js";
import { loginForm } from "@/store/logIn";

export default {
  name: "CustomDataTable",
  components: {
    ProgressCol,
    CommentCol,
    StatusCol,
    Pagination,
  },
  data() {
    const leadStore = useLeadsStore();
    return {
      leadStore,
      snapchatIcon,
      xIcon,
      instagramIcon,
      facebookIcon,
      tiktokIcon,
      phoneIcon,
      LinkedInIcon,
      dialog: false,
      search: "",
      selected: [],
      agents: [],
      currentLeadId: null,
      generalStore: useGeneralStore(),
      loginStore: loginForm(),
    };
  },
  computed: {
    headers() {
      return this.leadStore.headers;
    },
    leads() {
      return this.leadStore.leads;
    },
    currentPage: {
      get() {
        return this.leadStore.current_page;
      },
      set(val) {
        this.leadStore.current_page = val;
        this.leadStore.getAllLeads();
      },
    },
    itemsPerPage: {
      get() {
        return this.leadStore.items_per_page;
      },
      set(val) {
        this.leadStore.items_per_page = val;
        this.leadStore.current_page = 1;
        this.leadStore.getAllLeads();
      },
    },
    totalItems() {
      return this.leadStore.totalItems;
    },
  },
  mounted() {
    this.leadStore.getAllLeads();
    this.fetchAgents();
  },
  methods: {
    handleClickPermission(leadId) {
      if (!this.hasWritePermission) return;
      this.openAssignDialog(leadId);
    },

    hasWritePermission() {
      return this.store?.permissions?.some((p) =>
        [
          "leads-managment.update",
          "leads-managment.create",
          "leads-managment.delete",
        ].includes(p)
      );
    },
    HavePermission(p) {
      return this.loginStore?.permissions?.includes(p) || false;
    },
    updateCurrentPage(val) {
      this.leadStore.currentPage = val;
      this.leadStore.getAllLeads();
    },
    updateItemsPerPage(val) {
      this.leadStore.itemsPerPage = val;
      this.leadStore.currentPage = 1;
      this.leadStore.getAllLeads();
    },
    openAssignDialog(leadId) {
      this.currentLeadId = leadId;
      const lead = this.leads.find((l) => l.id === leadId);
      this.selected = lead?.assignee?.map((a) => a.id) || [];
      this.dialog = true;
    },
    async fetchAgents() {
      try {
        const response = await apiClient.get("/leads-managment/all-agents");
        this.agents = response.data.data;
      } catch (error) {
        console.error("Error fetching agents:", error);
      }
    },
    async toggleAssignAgent(agentId) {
      if (!this.currentLeadId) return;
      const isChecked = this.selected.includes(agentId);
      try {
        if (!isChecked) {
          const formData = new FormData();
          formData.append("agent_id[0]", agentId);
          await apiClient.post(
            `/leads-managment/assign-agents/${this.currentLeadId}`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          this.generalStore.showSnackbar("Agent added", "success");
        } else {
          await apiClient.get(
            `/leads-managment/delete/assign-agents/${this.currentLeadId}/agent=${agentId}`
          );
          this.generalStore.showSnackbar("Agent removed", "success");
        }
        await this.leadStore.getAllLeads();
        const updatedLead = this.leads.find((l) => l.id === this.currentLeadId);
        this.selected = updatedLead?.assignee?.map((a) => a.id) || [];
      } catch (err) {
        this.generalStore.showSnackbar("Operation failed", "error");
      }
    },
  },
};
</script>

<style>
.table-container .v-table {
  margin: 0px !important;
}

.plus-btn {
  width: 38px;
  height: 38px;
  min-width: 38px !important;
  border-radius: 50%;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  box-shadow: none;
}

.table-container .v-table .v-data-table-footer {
  justify-content: space-between !important;
}

.table-container .v-table .v-table__wrapper table thead {
  background: #edf1f1;
  color: #535862;
}

.table-container .v-table .v-table__wrapper table tbody tr:hover {
  background: #adadad27;
}

.table-container .v-table .v-table__wrapper table tbody tr td {
  padding: 16px 24px 16px 24px;
}

.data-table-no-border .v-table__wrapper>table>tbody>tr:not(:last-child)>td,
.data-table-no-border .v-table__wrapper>table>tbody>tr:not(:last-child)>th {
  border: none !important;
}

.data-table-no-border>.v-table__wrapper>table>tbody>tr>th,
.data-table-no-border>.v-table__wrapper>table>thead>tr>th,
.data-table-no-border>.v-table__wrapper>table>tfoot>tr>th {
  border: none !important;
}
</style>

<style scoped>
.table-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.table-container {
  width: 100%;
  position: relative;
  overflow-x: auto;
}

.v-data-table {
  width: 100%;
  margin: 1rem 0;
}

:deep(.v-data-table__wrapper) {
  overflow-x: auto;
  width: 100%;
}

:deep(.v-data-table > .v-data-table__wrapper > table) {
  width: 100%;
  white-space: nowrap;
}

:deep(.v-data-table th) {
  white-space: nowrap;
  min-width: 120px;
}

:deep(.v-pagination__item--is-active) {
  background-color: #237276 !important;
  color: #ffffff !important;
  font-weight: bold;
  border-radius: 4px;
}

.phone-link {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666666;
  text-decoration: none;
}

.phone-link:hover {
  text-decoration: underline;
}

:deep(.v-data-table) {
  text-transform: capitalize;
}

.dotted-circle-btn {
  width: 1.4rem !important;
  height: 1.4rem !important;
  border: 2px dashed #bbb;
  border-radius: 50%;
  background-color: transparent;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  box-shadow: none !important;
}

.dotted-circle-btn:hover {
  color: #117e3e;
}

.agent-list {
  max-height: 250px;
  overflow-y: scroll;
  box-shadow: none !important;
}

.agent-item {
  border-radius: 8px;
  transition: background-color 0.2s;
  background-color: #fafafa;
  margin: 8px 0;
}

.agent-item:hover {
  background-color: #eeeeee;
  cursor: pointer;
}

.agent-name {
  color: #0a7b6c;
  font-weight: 500;
}

:deep(.v-overlay__scrim) {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

:deep(.v-overlay__content > .v-card) {
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.04) !important;
}

.add-assi input {
  padding: 0 !important;
}
</style>
